import * as React from 'react';

const useMouseOverAndOut = (dataAtrCustomEventName: string, parentSelector: string) => {
  const [currentElem, setCurrentElm] = React.useState<HTMLElement | null>(null);

  const mouseOverHandler = React.useCallback(
    (event: any) => {
      try {
        if (currentElem) return;
        const target = event.target.closest(parentSelector);
        const id = target?.dataset?.[dataAtrCustomEventName];
        setCurrentElm(target);
        if (!id) return;
        target.dispatchEvent(new CustomEvent(id, { detail: true, bubbles: true }));
      } catch (err: any) {
        console.error(err.message); // eslint-disable-line no-console
      }
    },
    [currentElem, parentSelector, dataAtrCustomEventName]
  );

  const mouseOutHandler = React.useCallback(
    (event: any) => {
      try {
        if (!currentElem) return;
        let { relatedTarget } = event;
        while (relatedTarget) {
          if (relatedTarget === currentElem) return;
          relatedTarget = relatedTarget.parentNode;
        }
        const id = currentElem?.dataset?.[dataAtrCustomEventName];
        if (!id) return;
        currentElem.dispatchEvent(new CustomEvent(id, { detail: false, bubbles: true }));
        setCurrentElm(null);
      } catch (err: any) {
        console.error(err.message); // eslint-disable-line no-console
      }
    },
    [currentElem, dataAtrCustomEventName]
  );

  return {
    mouseOverHandler,
    mouseOutHandler,
  };
};

export default useMouseOverAndOut;
